import { CadastroEmAnalise } from "./CadastroEmAnalise";

export default CadastroEmAnalise;